'use client';

import caretRight from '@iconify/icons-carbon/caret-right';
import { Box, Typography } from '@mui/material';
import { alpha, styled, useTheme } from '@mui/material/styles';

import { IconButtonAnimate } from '@larvitu/shared/framer-motion/utils';
import { Iconify } from '@larvitu/shared/mui/ui-components';

import type { IconifyIcon } from '@iconify/react';
import type { BoxProps } from '@mui/material';
import type { FC } from 'react';

const RootStyle = styled( Box )(({ theme }) => ({
  zIndex: 9,
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  bottom: theme.spacing( 2 ),
  right: theme.spacing( 2 ),
  color: theme.palette.common.white,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha( theme.palette.grey[900], 0.48 ),
}));

const ArrowStyle = styled( IconButtonAnimate )(({ theme }) => ({
  padding: 6,
  opacity: 0.48,
  color: theme.palette.common.white,
  '&:hover': { opacity: 1 },
}));

// ----------------------------------------------------------------------

export interface CarouselArrowIndexProps extends BoxProps {
  customIcon?: IconifyIcon;
  index: number;
  total: number;
  onNext?: VoidFunction;
  onPrevious?: VoidFunction;
}

export const CarouselArrowsIndex: FC<CarouselArrowIndexProps> = ({
  customIcon, // Set icon right
  index,
  total,
  onNext,
  onPrevious,
  ...other
}) => {
  const theme = useTheme();
  const isRTL = theme.direction === 'rtl';

  return (
    <RootStyle {...other}>
      <ArrowStyle size="small" onClick={onPrevious}>
        <Iconify
          icon={customIcon ? customIcon : caretRight}
          sx={{
            width: 20,
            height: 20,
            transform: ' scaleX(-1)',
            ...(isRTL && { transform: ' scaleX(1)' }),
          }}
        />
      </ArrowStyle>

      <Typography variant="subtitle2">
        {index + 1}/{total}
      </Typography>

      <ArrowStyle size="small" onClick={onNext}>
        <Iconify
          icon={customIcon ? customIcon : caretRight}
          sx={{
            width: 20,
            height: 20,
            ...(isRTL && { transform: ' scaleX(-1)' }),
          }}
        />
      </ArrowStyle>
    </RootStyle>
  );
};
